import React from 'react';
import AsyncSelect from 'shared/inputs/AsyncSelect';
import AsyncMultiSelect from 'shared/inputs/AsyncMultiSelect';
import { getLocationsLookup } from 'src/fetch/locations';
import cm from './LocationsDropdown.module.scss';

const renderAddressOption = (li, itemProps) => {
  const address = itemProps?.dataItem?.fullDisplayAddress || '';
  const itemChildren = (
    <span
      className={cm.item}
    >
      <div
        style={{
          flexBasis: '100%',
        }}
      >
        {li.props.children}
      </div>
      {
        address && (
          <div
            className={cm.address}
          >
            {`${address}`}
          </div>
        )
      }
    </span>
  );
  return React.cloneElement(li, li.props, itemChildren);
};

const LocationAsyncSelect = ({ isMultiSelect = false, ...props }) => (isMultiSelect ? (
  <AsyncMultiSelect
    getData={(search, params) => getLocationsLookup({ search, ids: params?.ids })}
    textField='name'
    dataItemKey='id'
    onItemOpen={() => window.open(
      `organizations/locations/${props.value?.id}`,
      '_blank',
    )}
    itemRender={renderAddressOption}
    {...props}
  />
) : (
  <AsyncSelect
    getData={(search, params) => getLocationsLookup({ search, ids: params?.ids })}
    textField='name'
    dataItemKey='id'
    onItemOpen={() => window.open(
      `organizations/locations/${props.value?.id}`,
      '_blank',
    )}
    itemRender={renderAddressOption}
    {...props}
  />
));

export default LocationAsyncSelect;
